import React from 'react';
import style from './FeatureFlag.module.scss';
import Card from './components/Card';
import FlagMap from './FlagMap';

const FeatureFlag = () => (
  <div className={style.featureFlags}>
    {FlagMap.map(flag => (
      <Card key={flag.name} {...flag} />
    ))}
  </div>
);

export default FeatureFlag;
